import React from "react";
import { Divider } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { formatCurrency } from "../../../../../../utils/data-format-enchanters/currency-enchanter";

import { BookedForSalesEvents, BookedForSalesProduct, CustomerFacility } from "../../../../../../api-client";

import BVShimmer from "../../../../../../common/components/BVShimmers/BVShimmer/bv-shimmer";
import BVCustomersProductCard from "./components/BVCustomerProductCard/bv-customer-product-card";

import "./bv-customer-event-recap.scss";
import BVCustomTooltip from "./components/BVCustomerProductCard/BVCustomTooltip/bv-custom-tooltip";

interface IBVCustomersEventRecap {
	facilities?: CustomerFacility[];
	bookedForSalesProducts?: BookedForSalesProduct[];
	bookedForSalesProductsLoading: boolean;
	customerBookedForSalesEventRecap?: BookedForSalesEvents;
	customerBookedForSalesEventRecapLoading: boolean;
	refreshBookedForSales: () => void;
}

const BVCustomersEventRecap: React.FC<IBVCustomersEventRecap> = (props) => {
	const handleRefreshClick = () => {
        props.refreshBookedForSales();
    }

	return (
		<React.Fragment>
			{(props.bookedForSalesProducts &&
				props.bookedForSalesProducts?.length > 0) ||
			(props.bookedForSalesProductsLoading &&
				props.customerBookedForSalesEventRecap) ||
			props.customerBookedForSalesEventRecapLoading ? (
				<React.Fragment>
					<BVShimmer
						type={"shimmer-group"}
						loading={props.customerBookedForSalesEventRecapLoading}
					>
						<div className="event-recap-container">
							<div className="event-recap-header">
								<h2 className="event-recap-title">Event recap</h2>
								<BVCustomTooltip
									className="reload-bfs" 
									title={'Refresh BFS'} 
									onClick={handleRefreshClick}
								>
									<ReloadOutlined />
								</BVCustomTooltip>
							</div>
							<div className="event-recap-wrapper">
								<div className="grid-container">
									<div></div>
									<div></div>
									<div></div>
									<div className="label">Value</div>
									<div className="label">Items</div>
									<div className="label">Items to be confirmed:</div>
									<div>
										{props.customerBookedForSalesEventRecap?.itemToBeConfirmed !== 0
											? props.customerBookedForSalesEventRecap?.itemToBeConfirmed
											: "-"}
									</div>
									<div className="label">Watches confirmed:</div>
									<div>
										<div className="value-container">
											<div>
												{props.customerBookedForSalesEventRecap?.valueWatchesConfirmed?.amount !== 0
													? formatCurrency(
														props.customerBookedForSalesEventRecap?.valueWatchesConfirmed?.amount,
														props.customerBookedForSalesEventRecap?.valueWatchesConfirmed?.currency
														)
													: "-"}
											</div>
											{props.customerBookedForSalesEventRecap?.localValueWatchesConfirmed?.currency !== "EUR" &&
												props.customerBookedForSalesEventRecap?.localValueWatchesConfirmed?.currency !== null &&
												props.customerBookedForSalesEventRecap?.localValueWatchesConfirmed?.amount !== 0 
											? (
												<div className="label">
													{formatCurrency(
														props.customerBookedForSalesEventRecap?.localValueWatchesConfirmed?.amount,
														props.customerBookedForSalesEventRecap?.localValueWatchesConfirmed?.currency
													)}
												</div>
											) : null}
										</div>
									</div>
									<div>
										{props.customerBookedForSalesEventRecap?.watchesConfirmed !== 0 
											? props.customerBookedForSalesEventRecap?.watchesConfirmed
											: "-"}
									</div>
									<div className="label">Items confirmed:</div>
									<div>
										{props.customerBookedForSalesEventRecap?.itemConfirmed !== 0 
											? props.customerBookedForSalesEventRecap?.itemConfirmed
											: "-"}
									</div>
									<div className="label">Jewelry confirmed:</div>
									<div>
										<div className="value-container">
											<div>
												{props.customerBookedForSalesEventRecap?.valueJewelryConfirmed?.amount !== 0
													? formatCurrency(
															props.customerBookedForSalesEventRecap?.valueJewelryConfirmed?.amount,
															props.customerBookedForSalesEventRecap?.valueJewelryConfirmed?.currency
													)
													: "-"}
											</div>
											{props.customerBookedForSalesEventRecap?.localValueJewelryConfirmed?.currency !== "EUR" &&
												props.customerBookedForSalesEventRecap?.localValueJewelryConfirmed?.currency !== null &&
												props.customerBookedForSalesEventRecap?.localValueJewelryConfirmed?.amount !== 0 
											? (
												<div className="label">
													{formatCurrency(
														props.customerBookedForSalesEventRecap?.localValueJewelryConfirmed?.amount,
														props.customerBookedForSalesEventRecap?.localValueJewelryConfirmed?.currency
													)}
												</div>
											) : null}
										</div>
									</div>
									<div>
										{props.customerBookedForSalesEventRecap?.jewelryConfirmed !== 0 
											? props.customerBookedForSalesEventRecap?.jewelryConfirmed
											: "-"}
									</div>
								</div>
							</div>
						</div>
					</BVShimmer>

					<BVShimmer
						type={"shimmer-group"}
						loading={props.bookedForSalesProductsLoading}
					>
						<div className="product-wrapper">
							<Divider />
							{props.bookedForSalesProducts?.map((x, index) => (
								<BVCustomersProductCard
									key={index}
									bookedForSalesProduct={x}
									facilities={props.facilities}
									refreshBookedForSales={props.refreshBookedForSales}
								/>
							))}
						</div>
					</BVShimmer>
				</React.Fragment>
			) : null}
		</React.Fragment>
	);
};

export default BVCustomersEventRecap;